import { NavLink, Link } from "react-router-dom";
import { Apple } from "lucide-react";

const linkClass = ({ isActive }) =>
  `rounded-full px-4 py-2 text-sm font-bold transition-[background-color,color] duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 ${
    isActive
      ? "bg-[#1FBCA2] text-[#1A1D1E]"
      : "text-[#1A1D1E] hover:bg-[#1A1D1E]/5"
  }`;

export const Nav = () => (
  <header className="sticky top-0 z-50 border-b-2 border-[#1A1D1E]/10 bg-[#FAF9F6]/85 backdrop-blur-xl">
    <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12" aria-label="Main">
      <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 rounded-full">
        <img
          src="/app-icon.jpg"
          alt="TriviaPro app icon"
          className="h-10 w-10 rounded-[12px] border-2 border-[#1A1D1E] object-cover shadow-[0_3px_0_0_#1A1D1E]"
        />
        <span className="font-display text-2xl font-semibold tracking-tight">
          Trivia
          <span className="ml-1.5 rounded-full bg-[#FFC837] px-2 py-0.5 align-middle text-xs font-bold uppercase tracking-widest">
            Pro
          </span>
        </span>
      </Link>
      <div className="flex items-center gap-2 md:gap-4">
        <NavLink to="/" end data-testid="nav-home-link" className={linkClass}>
          Home
        </NavLink>
        <NavLink to="/about" data-testid="nav-about-link" className={linkClass}>
          About
        </NavLink>
        <NavLink to="/privacy" data-testid="nav-privacy-link" className={linkClass}>
          Privacy Policy
        </NavLink>
        <a
          href="#download"
          data-testid="nav-download-button"
          className="hidden items-center gap-2 rounded-full border-2 border-[#1A1D1E] bg-[#1A1D1E] px-5 py-2.5 font-display text-sm font-semibold text-white shadow-[0_4px_0_0_rgba(26,29,30,0.35)] transition-[transform,box-shadow] duration-150 hover:translate-y-[2px] hover:shadow-[0_2px_0_0_rgba(26,29,30,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FFC837]/60 md:inline-flex"
        >
          <Apple className="h-4 w-4 fill-white" />
          Get the app
        </a>
      </div>
    </nav>
  </header>
);
